import {
  ThemeProvider as CompThemeProvider,
  themeConfig,
} from "@sinecycle/growcomponents";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { queryClient } from "./configs/query/queryConfig";

import "./index.css";
import { logRocket } from "./lib/error-monitor/logrocket";
import { errorMonitor } from "./lib/error-monitor/sentry/errorMonitor";
import { QueryProvider } from "./providers/queryProvider";
import { StoreProvider } from "./providers/storeProvider";
import { ThemeProvider } from "./providers/themeProvider";
errorMonitor.init();
logRocket.init();
logRocket.logSessionURL();
ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <StoreProvider>
      <CompThemeProvider>
        <ThemeProvider
          theme={{
            ...themeConfig,
            components: {
              ...themeConfig.components,
              Descriptions: {
                itemPaddingBottom: 4,
                titleColor: "#8c8c8c",
              },
            },
          }}
        >
          <QueryProvider client={queryClient}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </QueryProvider>
        </ThemeProvider>
      </CompThemeProvider>
    </StoreProvider>
  </React.StrictMode>
);
